import React, { useMemo } from 'react';
import { Redirect, Route } from 'react-router-dom';

import PageLoader from 'components/Shared/PageLoader';
import useCustomObservable from 'hooks/useCustomObservable';
import tokenService, { type IAuth } from 'services/token/index';
import userService from 'services/user/index';
import { type User } from 'services/user/types';

const Gateway = ({ component: Component, ...rest }: any) => {
  const { value: userData } = useCustomObservable<User, string, string>(() => userService.getUser(), null);
  const { value: storedToken } = useCustomObservable<IAuth, string, string>(() => tokenService.getTokens(), null);

  const haveNoToken = useMemo(() => !storedToken, [storedToken]);
  const isProducer = useMemo(() => !!userData?.is_producer, [userData]);

  if (haveNoToken) {
    return <PageLoader />;
  }

  if (!isProducer) {
    <Redirect to='/' />;
  }

  return <Route {...rest} render={props => <Component classes={rest.classes} {...props} />} />;
};
export default Gateway;
